import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Card from 'components/inputs/Card';
import { MdClose } from 'react-icons/md';
import { Row, Col, Modal } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import Button from 'components/inputs/Button';
import { useSelector, useDispatch } from 'react-redux';
import { FETCH_CHARGING_STATION } from 'actions/chargingStation';
import { RESTART_CHARGER } from 'actions/charger';
import _ from 'lodash';
import * as Yup from 'yup';
import { UPDATE_STATUS_CODE } from 'components/common/constant';
import Select from 'components/inputs/Select';
import ConfirmationModal from './ConfirmationModal';

const ChargerResetForm = (props) => {
  const { onClose = _.noop(), isEdit, onSuccess = _.noop() } = props;
  const dispatch = useDispatch();

  const allChargingStations = useSelector((state) => state.chargingStation.chargingStations);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [restartData, setRestartData] = useState(null);

  const restartCharger = useCallback((data) => {
    let payload = {};

    if (
      data.option === 'Specific Stations' &&
      Array.isArray(data.charging_stations) &&
      !data.charging_stations.includes('All') &&
      data.charging_stations.length > 0
    ) {
      payload = {
        charging_stations: data.charging_stations,
      };
    }

    dispatch({
      type: RESTART_CHARGER,
      payload,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          onClose();
          onSuccess();
        }
      },
    });
  }, []);

  const getChargingStations = useCallback((data = {}) => {
    const stationData = {
      ...data,
      request_all: true,
    };
    dispatch({ type: FETCH_CHARGING_STATION, payload: stationData });
  }, []);

  useEffect(() => {
    getChargingStations();
  }, []);

  const initialValues = {
    option: '',
    charging_stations: [],
  };

  const ResetFormSchema = Yup.object().shape({
    option: Yup.string().required('Select any one option!'),
    charging_stations: Yup.array().when('option', {
      is: 'Specific Stations',
      then: Yup.array().min(1, 'Please select at least one station!').of(Yup.string().required()).required('Please select at least one station!'),
      otherwise: Yup.array().notRequired(),
    }),
  });

  return (
    <React.Fragment>
      <div className="pricing-form-page__main">
        <Card>
          <div className="pricing-form-header__block">
            <div className="pricing-header-name">
              <span>{'Soft Restart'}</span>
            </div>
            <div className="close-btn">
              <MdClose size={30} color="#be210b" onClick={onClose} />
            </div>
          </div>
          <div className="pricing-form-body__block">
            <div className="pricing-form--block">
              <Formik
                enableReinitialize={!!isEdit}
                initialValues={initialValues}
                validationSchema={ResetFormSchema}
                onSubmit={(values, { setSubmitting }) => {
                  const restartChargerData = {
                    option: values.option,
                    charging_stations: values.charging_stations || [],
                  };

                  setShowConfirmationModal(true);
                  setRestartData(restartChargerData);
                  setSubmitting(false);
                }}
              >
                {({ values, handleSubmit, setFieldValue, errors, touched }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col xl={12} md={6}>
                        <Select
                          isRequired
                          label={'Select Option'}
                          placeholder={'Select Option'}
                          options={[
                            { label: 'All Chargers', value: 'All Chargers' },
                            { label: 'Specific Stations', value: 'Specific Stations' },
                          ]}
                          name="option"
                          value={values.option}
                          onChange={(val) => {
                            setFieldValue('option', val);
                            if (val !== 'Specific Stations') {
                              setFieldValue('charging_stations', []);
                            }
                          }}
                          error={errors.option && touched.option ? errors.option : null}
                        />
                      </Col>
                      {values.option === 'Specific Stations' && (
                        <Col xl={12} md={6}>
                          <Select
                            isRequired
                            label={'Select Station'}
                            placeholder={'Select Station'}
                            options={[
                              { label: 'All', value: 'All' },
                              ..._.map(allChargingStations, (station) => {
                                return { label: station.name, value: station.id };
                              }),
                            ]}
                            isMulti
                            name="charging_stations"
                            value={values.charging_stations}
                            onChange={(val) => {
                              setFieldValue(`charging_stations`, val);
                            }}
                            error={errors.charging_stations && touched.charging_stations ? errors.charging_stations : null}
                          />
                        </Col>
                      )}
                    </Row>
                    <div className="form-btn--block">
                      <Button className="pricing-form-btn cancel-btn" onClick={onClose}>
                        {'Cancel'}
                      </Button>

                      <Button className="pricing-form-btn create-btn" type="submit">
                        {'Submit'}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
        {showConfirmationModal && (
          <Modal show={showConfirmationModal} size="xxs" centered>
            <ConfirmationModal onClose={() => setShowConfirmationModal(false)} onConfirm={() => restartCharger(restartData)} />
          </Modal>
        )}
      </div>
    </React.Fragment>
  );
};
ChargerResetForm.propTypes = {
  onClose: PropTypes.func,
  isEdit: PropTypes.bool,
  onSuccess: PropTypes.func,
};
export default ChargerResetForm;
